export default __webpack_public_path__ + "static/media/edit-outline-black.fc0a1630.svg";